<template>
  <div class="content-component">
    <div class="content-component__left">
      <span
        :class="[
          'content-component__title',
          this.isRequire ? 'content-component__title--required' : '',
        ]"
        >{{ title }}</span
      >
    </div>
    <div class="content-component__right">
      <!-- 只读的内容 -->
      <span v-if="mode === 'read-only'">{{ content }}</span>
      <!-- 输入框 -->
      <el-input
        v-if="mode === 'input'"
        v-model="inputValue"
        class="content-component__right__input"
        :placeholder="placeholder"
        @change="handleChange"
        type="text"
      />
      <!-- 选择器 -->
      <!-- v-model="inputValue" -->
      <el-select
        v-if="mode === 'selector'"
        :value="value"
        class="content-component__right__input"
        :placeholder="placeholder"
        @change="handleChange"
        :multiple="multiple"
        :disabled="disabled"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.name"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <!-- v-model="inputValue" -->
      <el-cascader
        class="content-component__right__input"
        v-if="mode === 'cascader'"
        :value="value"
        :options="cascaderOptions"
        :props="areaCascaderProps"
        :placeholder="placeholder"
        @change="handleChange"
      ></el-cascader>
      <!-- 单位（如：万） -->
      <span class="content-component__right__unit" v-if="unit">{{ unit }}</span>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: null,
    // 组件的模式 （ read-only / input / selector / cascader / ）
    mode: {
      type: String,
      default: 'read-only'
    },
    // 单位（如：万）
    unit: String,
    // 所属标题
    title: {
      type: String,
      default: ''
    },
    // 显示的内容
    content: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    // require 则前缀 * 号
    isRequire: {
      type: Boolean,
      default: false
    },
    // 选择器 -> 所展示可选择的数据
    selectOptions: {
      type: [Object, Array]
    },
    cascaderOptions: {
      type: [Object, Array]
    },
    // 默认值
    defaultValue: {
      type: [Number, String, Array]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: Boolean
  },
  data() {
    return {
      inputValue: '',
      areaCascaderProps: {
        value: 'id',
        label: 'name'
      }
    }
  },
  watch: {
    defaultValue(newVal) {
      if (!newVal) return
      this.inputValue = this.defaultValue
    }
  },
  mounted() {
    this.inputValue = this.defaultValue
  },
  methods: {
    handleChange(val) {
      if (this.title === '经营地址：') {
        this.$emit('changeEnterpriseArea')
      }
      this.$emit('change', val)
    }
  },
  filters: {
    // 如果是必填项 则前置 *
    formatTitle(text, isRequire) {
      return isRequire ? `*${text}` : text
    }
  }
}
</script>
<style lang="scss" scoped>
.content-component {
  @include clearfix;
  margin: 12px 0;
  &__left {
    float: left;
    width: 50%;
    padding-right: 90px;
    margin-right: -68px;
    text-align: right;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
  }
  &__title--required {
    &::before {
      content: '*';
      color: #f56c6c;
      font-size: 14px;
      position: relative;
      left: -5px;
    }
  }
  &__right {
    float: left;
    width: 50%;
    text-align: left;
    line-height: 40px;
    box-sizing: border-box;

    &__input {
      width: 260px;
    }

    &__unit {
      font-size: 14px;
      margin-left: 10px;
    }
  }
}
</style>
